










import { LowElement } from '@/types/Element';
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseOptions from './BaseOptions';

@Component({})
export default class Layout extends BaseOptions {
  /**
   * 取消
   */
  handleClose () {
    this.$store.commit("page/SET_CURRENT", undefined);
  }
}

